import apiClient from "../../utils/interceptor"
import { ApiResponse, RoleData, CreateRoleParams, CreateRoleResponse, UpdateRoleParams } from "./interface";
import { API_URLS } from "../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get all roles
export const getAllRoles = async (): Promise<ApiResponse<RoleData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<RoleData[]>>(
            API_URLS.ROLE.GET_ROLES,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching roles:", error);
        throw error;
    }
};

// Function to create a role
export const createRole = async (
    roleParams: CreateRoleParams
): Promise<ApiResponse<CreateRoleResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateRoleResponse>>(
            API_URLS.ROLE.CREATE_ROLE,
            roleParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating role:", error);
        throw error;
    }
};

// Function to update a role
export const updateRole = async (
    roleData: UpdateRoleParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.ROLE.UPDATE_ROLE,
            roleData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating role:", error);
        throw error;
    }
};

// Function to delete a role
export const deleteRole = async (
    roleName: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            `${API_URLS.ROLE.DELETE_ROLE}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { role_name: roleName },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting role:", error);
        throw error;
    }
};

// Function to get only role names
export const getRoleNames = async (): Promise<ApiResponse<string[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<string[]>>(
            API_URLS.ROLE.GET_ROLE_NAMES,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching role names:", error);
        throw error;
    }
};